// Aangepaste versie die direct in order attributes blijft
class SimpleCartTracker {
  constructor() {
    this.init();
  }

  async init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.addTrackingToCart();
    });
    this.interceptCartUpdates();
  }

  async addTrackingToCart() {
    const cart = await this.getCart();
    
    if (cart.item_count > 0 && window.clickTracker) {
      const trackingData = window.clickTracker.getData();
      if (trackingData) {
        await this.updateCartWithTracking(trackingData);
      }
    }
  }

  async getCart() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      return { item_count: 0 };
    }
  }

  async updateCartWithTracking(trackingData) {
    try {
      const formData = new FormData();
      // Direct in order attributes (niet metafield)
      formData.append('attributes[tracking_data]', JSON.stringify(trackingData));

      await fetch('/cart/update.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
    } catch (error) {
      console.error(error);
    }
  }

  interceptCartUpdates() {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      if (args[0]?.includes('/cart/add')) {
        setTimeout(() => this.addTrackingToCart(), 500);
      }
      return response;
    };
  }
}

new SimpleCartTracker();